import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref } from "vue";
const _hoisted_1 = { class: "prod-offers__switch" };
const _hoisted_2 = { class: "prod-offers__main" };
const _hoisted_3 = {
    key: 1,
    class: "prod-offers__main"
};
import { inject, ref, watch } from "vue";
import LegacyOfferList from "./components/LegacyOfferList.vue";
import OfferSelector from "../components/OfferSelector.vue";
import Toggle from "../../../components/Toggle.vue";
import cookies from "js-cookie";
import PreOrder from "../components/PreOrder.vue";
import DeliveryInfo from "./components/DeliveryInfo.vue";
import PersonalDiscountNote from "./components/PersonalDiscountNote.vue";
import NoDiscountInfo from "./components/NoDiscountInfo.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductCardApp',
    props: {
        product: { type: Object, required: true },
        types: { type: Array, required: true },
        delivery: { type: Object, required: true },
        newInterface: { type: Boolean },
    },
    setup(__props) {
        const props = __props;
        const newInterface = ref(props.newInterface);
        const available = !!props.product.offers.find(offer => offer.active);
        const offer = inject('offer');
        const type = inject('type');
        watch(newInterface, value => {
            cookies.set('legacy_offer_list_view', JSON.stringify(!value), { expires: 365 });
        });
        return (_ctx, _cache) => {
            var _a;
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(Toggle, {
                        label: "Новый вид подбора товаров",
                        modelValue: newInterface.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((newInterface).value = $event))
                    }, null, 8 /* PROPS */, ["modelValue"])
                ]),
                _cache[2] || (_cache[2] = _createTextVNode()),
                available
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_2, [
                            (newInterface.value)
                                ? (_openBlock(), _createBlock(OfferSelector, {
                                    key: 0,
                                    types: __props.types,
                                    product: __props.product
                                }, null, 8 /* PROPS */, ["types", "product"]))
                                : (_openBlock(), _createBlock(LegacyOfferList, {
                                    key: 1,
                                    product: __props.product,
                                    types: __props.types
                                }, null, 8 /* PROPS */, ["product", "types"]))
                        ]),
                        _cache[1] || (_cache[1] = _createTextVNode()),
                        (__props.product.personalDiscount)
                            ? (_openBlock(), _createBlock(PersonalDiscountNote, { key: 0 }))
                            : (!__props.product.sale)
                                ? (_openBlock(), _createBlock(NoDiscountInfo, {
                                    key: 1,
                                    id: __props.product.id
                                }, null, 8 /* PROPS */, ["id"]))
                                : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(PreOrder, {
                            "product-id": __props.product.id,
                            available: available
                        }, null, 8 /* PROPS */, ["product-id"])
                    ])),
                _cache[3] || (_cache[3] = _createTextVNode()),
                (available && !((_a = _unref(type)) === null || _a === void 0 ? void 0 : _a.disabled))
                    ? (_openBlock(), _createBlock(DeliveryInfo, {
                        key: 2,
                        moscow: __props.delivery.moscow,
                        "st-petersburg": __props.delivery.stPetersburg,
                        "extra-day": __props.delivery.extraDay,
                        "same-day-price": __props.delivery.sameDayPrice
                    }, null, 8 /* PROPS */, ["moscow", "st-petersburg", "extra-day", "same-day-price"]))
                    : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
